import axios, { AxiosRequestConfig } from 'axios'

const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  timeout: 30000,
  timeoutErrorMessage: 'Request Timeout',
  responseType: 'json',
})

export const get = async <T>(route: string, config?: AxiosRequestConfig) => {
  const requestConfig: AxiosRequestConfig = {
    ...config,
    headers: {
      ...config?.headers,
    },
  }
  return api.get<T>(route, requestConfig)
}

export const post = async <T, U>(
  route: string,
  data: U,
  config?: AxiosRequestConfig
) => {
  const requestConfig: AxiosRequestConfig = {
    ...config,
    headers: {
      'Content-type': 'application/json; charset=UTF-8',
      ...config?.headers,
    },
  }

  return api.post<T>(route, data, requestConfig)
}

export default api
